import { inject, injectable } from "inversify";
import { Nullable } from "@core/domain/types/nullable.type";
import { UserSessionRepository } from "@authentication/data/repositories/user-session.repository";
import { UpdateDerivationData } from "@catalogue/domain/usecases/update-derivation.usecase";

@injectable()
export class UpdateDerivationMapper {
    constructor(
        @inject(UserSessionRepository)
        private readonly userSessionRepository: UserSessionRepository,
    ) { }

    map(derivation: UpdateDerivationData): Nullable<any> {
        if (!derivation) return null;

        try {
            return {
                beneficiary: derivation.beneficiaryId,
                service: derivation.serviceId,
                entity: derivation.entityId,
                status: derivation.status,
                reason: derivation.reason,
                documents: derivation.documentIds || [],
                authorization_file: derivation.authorizationFileId,
                notify_admin_id: derivation.notify_admin_id,
            };
        } catch (error) {
            console.error("Error mapping update derivation data:", error, derivation);
            return null;
        }
    }
}